/*
 * Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 */

export enum LocalStorageKeys {
    ID4_LANGUAGE = 'ID4_LANGUAGE',
    ID4_REGION = 'ID4_REGION'
}

export const setLocalStorageItem = (key: LocalStorageKeys, value: string) => {
    localStorage.setItem(key, value);
};

export const getLocalStorageItem = (key: LocalStorageKeys): string => {
    return localStorage.getItem(key);
};
